import { Center, Column, Row, Typography } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents/CenteredSpinner';
import { EmptyScreen, SortingArrow, TSortValue } from '~/commonComponents';
import { colors } from '@tempmee/tailwind';
import { CreatePostingButton } from '~/components/PermanentJobsV2/CreatePostingButton';
import { IJobPostEntity, JobPostingSortableField } from '~/domain/PermanentJobs';
import BriefcaseEmptyScreenIcon from '~/images/briefcase-empty-screen-icon.svg';
import { JobCard } from '../JobCard';

interface IDefaultTableProps {
  data: IJobPostEntity[];
  formSorting: TSortValue;
  isLoading: boolean;
  onSortChanges(formSorting: TSortValue): void;
}

export const DefaultTable = ({
  data,
  formSorting,
  isLoading,
  onSortChanges,
}: IDefaultTableProps) => {
  const isEmptyData = data.length === 0;

  if (!isLoading && isEmptyData) {
    return (
      <EmptyScreen
        Icon={() => (
          <img
            alt="briefcase-empty-screen-icon"
            src={BriefcaseEmptyScreenIcon}
            height={170}
            width={170}
          />
        )}
        title="No jobs posted yet!"
        description={
          <Column align="center" gap={12}>
            <Typography as="span" color={colors.neutral[500]}>
              You haven’t posted any jobs yet. Post your first
              <br />
              job to start connecting with qualified dental
              <br />
              professionals in your area!
            </Typography>
            <CreatePostingButton />
          </Column>
        }
      />
    );
  }

  return (
    <>
      <Column align="center">
        <Column gap={4} className="w-full max-w-[672px]">
          <Row align="center" justify="end" py={2}>
            <SortingArrow
              sorting={formSorting}
              name={JobPostingSortableField.CandidateCount}
              variant="primary"
              onChange={onSortChanges}
            >
              <Typography as="span" bold color={colors.primary[500]} variant="body1">
                Candidates
              </Typography>
            </SortingArrow>
          </Row>
          {!isLoading && data.map((it: IJobPostEntity) => <JobCard key={it.id} {...it} />)}
        </Column>
      </Column>
      {isLoading && (
        <Center style={{ marginBlock: 32 }}>
          <CenteredSpinner />
        </Center>
      )}
    </>
  );
};
